/* Guimarães Importados
   O banner do hero já traz o botão desenhado na arte. Este script cobre o
   primeiro slide com um link invisível para o slide inteiro ficar clicável
   (inclusive no mobile, onde o botão da arte fica pequeno demais para acertar). */
(function () {
  // não navega: o clique abre o pop-up do cupom (seção gi-cupom-popup)
  var DESTINO = '#';
  var ROTULO = 'Ver meu cupom de primeira compra';

  function aplicar() {
    var slides = document.querySelectorAll(
      '.swiper-slideshow-main .swiper-slide, .slideshow .swiper-slide'
    );
    if (!slides.length) return;
    var primeiro = slides[0];
    if (primeiro.querySelector('.gi-hero-link')) return;

    var a = document.createElement('a');
    a.className = 'gi-hero-link';
    a.href = DESTINO;
    a.setAttribute('data-gi-cupom', '');
    a.setAttribute('aria-label', ROTULO);
    a.style.cssText =
      'position:absolute;inset:0;z-index:3;display:block;' +
      'background:transparent;border:0;text-indent:-9999px;overflow:hidden';

    if (getComputedStyle(primeiro).position === 'static') {
      primeiro.style.position = 'relative';
    }
    primeiro.appendChild(a);
  }

  document.addEventListener('DOMContentLoaded', aplicar);
  document.addEventListener('shopify:section:load', aplicar);
  if (document.readyState !== 'loading') aplicar();
  // o swiper monta os slides depois; tenta de novo por alguns instantes
  var tentativas = 0;
  var t = setInterval(function () {
    aplicar();
    if (++tentativas > 20) clearInterval(t);
  }, 300);
})();
